<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="308"
    height="274"
    viewBox="0 0 308 274"
    fill="none"
  >
    <path
      d="M155.203 273.859V229.719H0.125V167.219L123.562 0.421875H276.297V159.406H307.938V229.719H276.297V273.859H155.203ZM101.297 159.406H155.203V125.422C155.203 111.75 156.57 91.6328 158.523 76.5938L154.617 76.0078C148.172 88.3125 141.727 99.0547 135.086 108.82L101.297 159.406Z"
      fill="#D7FF00"
    />
  </svg>
</template>
